// App main
import 'unfonts.css';
import 'virtual:svg-icons-register';
import '@/css/app.pcss';
import 'swiper/css';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import {Autoplay, Navigation, Pagination, Swiper} from 'swiper';
import Alpine from 'alpinejs';

Swiper.use([Navigation, Pagination, Autoplay]);
window['Swiper'] = Swiper;

document.documentElement.classList.remove('no-js');
window['app'] = {
    header() {
        return {
            openNode: -1,
            openMenu: false,
            openMobileSection: -1,
            isFixed: false,
            isVisible: true,
            lastScrollY: 0,
            scrollDelta: 0,
            init() {
                window.addEventListener('scroll', () => {
                    const y = window.scrollY;
                    if (y > this.lastScrollY) {
                        this.scrollDelta = 0;
                        if (y > 80) this.isVisible = false;
                    } else {
                        this.scrollDelta += this.lastScrollY - y;
                        if (this.scrollDelta >= 20) {
                            this.isFixed = true;
                            this.isVisible = true;
                        }
                    }
                    if (y <= 10) { this.isFixed = false; this.isVisible = true; }
                    this.lastScrollY = y;
                }, { passive: true });
            }
        };
    },
    // Wayfinding-pillen. Måler den naturlige bredden på hver hale og
    // legger den i `--wf-hale-bredde`, som CSS-en animerer mot på hover.
    // Se kommentaren over `.wf-hale` i app.pcss for hvorfor animasjonen
    // bruker bredde og ikke `grid-template-columns`.
    //
    // Målingen skjer med ResizeObserver og IKKE som en engangsmåling etter
    // `document.fonts.ready`. Grunnen er at `_layout.twig` inliner critical
    // CSS og laster hovedstilarket asynkront: kjører målingen før stilarket
    // er påført, mangler ikonet sin `size-4` og måler 0, og halen blir 24px
    // for kort — ekstern-ikonet klippes da bort av `overflow-hidden`.
    // Det er en kappløpssituasjon som er ustabil mellom builds og derfor
    // ubehagelig å feilsøke.
    //
    // Observatøren dekker samtidig fontlasting, resize og endret innhold.
    // Ingen tilbakekoblingsløkke: det observerte elementet er `w-max`, så
    // bredden er uavhengig av halens animerte bredde.
    wayfinding() {
        return {
            open: false,
            setup(el: HTMLElement) {
                const haler = el.querySelectorAll<HTMLElement>('.wf-hale');
                if (!haler.length) return;

                if (typeof ResizeObserver === 'undefined') {
                    haler.forEach((hale) => {
                        const innhold = hale.firstElementChild as HTMLElement | null;
                        if (innhold) hale.style.setProperty('--wf-hale-bredde', `${innhold.offsetWidth}px`);
                    });
                    return;
                }

                const observer = new ResizeObserver((oppforinger) => {
                    for (const oppforing of oppforinger) {
                        const innhold = oppforing.target as HTMLElement;
                        const hale = innhold.parentElement;
                        if (!hale) continue;
                        hale.style.setProperty('--wf-hale-bredde', `${Math.ceil(innhold.offsetWidth)}px`);
                    }
                });

                haler.forEach((hale) => {
                    const innhold = hale.firstElementChild;
                    if (innhold) observer.observe(innhold);
                });
            },

            // Nedtrekket og hover-utvidelsen er komplementer: pillen er
            // enten det ene eller det andre. Åpner du nedtrekket på en smal
            // viewport og drar vinduet bredere, ville `open` blitt stående
            // sann og panelet vist seg oppå desktop-pillen. Her nullstilles
            // den i stedet når hover-modus slår inn.
            //
            // Betingelsen MÅ være identisk med media-queryen i app.pcss.
            // Se kommentaren over `.wf-nedtrekk` der.
            lyttPaaModus() {
                const hovermodus = window.matchMedia('(min-width: 768px) and (hover: hover)');
                const synk = () => {
                    if (hovermodus.matches) this.open = false;
                };
                synk();
                hovermodus.addEventListener('change', synk);
            }
        };
    },
    // Karusell for moduler. Navigasjonsknappene slås opp INNE i `el` og
    // sendes som elementer, ikke som selektorstrenger — Swiper slår opp
    // strenger dokumentvidt, så to karuseller på samme side (forsiden har
    // `kortkarusell` og `videokarusell`) ville styrt hverandres piler.
    karusell() {
        return {
            progress: 0,
            locked: false,
            setup(el: HTMLElement) {
                const swiper = new Swiper(el, {
                    slidesPerView: 'auto',
                    grabCursor: true,
                    navigation: {
                        nextEl: el.querySelector('.swiper-button-next') as HTMLElement,
                        prevEl: el.querySelector('.swiper-button-prev') as HTMLElement
                    }
                });

                swiper.on('lock', () => { this.locked = true; });
                swiper.on('unlock', () => { this.locked = false; });
                swiper.on('slideChange', () => {
                    this.progress = parseInt(String(swiper.progress * 100));
                });

                this.locked = swiper.isLocked;
            }
        };
    },
    slideshow() {
        return {
            progress: 0,
            setup(el) {
                const modul = new Swiper(el, {
                    slidesPerView: "auto",
                    grabCursor: true,
                    scrollbar: {
                        el: ".swiper-scrollbar",
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                });

                modul.on('slideChange', (swiper) => {
                    this.progress = parseInt(swiper.progress * 100);
                });
            }
        }
    }
};
Alpine.start();
